<template>
  <div v-if="dialogVisible" class="radish-right" :style="{ 'z-index': zIndex }">
    <div class="radish-head">
      <div class="radish-title">人选查找</div>
      <div class="radish-btns"><el-button size="mini" icon="el-icon-close" circle @click="close"></el-button></div>
    </div>
    <div style="padding: 50px 15px;">
      <el-alert v-if="msg" :title="msg" type="warning" :closable="false"> </el-alert>
      <el-button v-if="!name && !phone" type="primary" size="mini" style="margin-top：5px" @click="reparse"
        >重新解析</el-button
      >
      <el-form :inline="true">
        <el-form-item label="姓名">
          <el-input v-model="name" size="mini" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <div style="display:flex;">
            <el-select v-model="country" size="mini" filterable placeholder="+86" style="width:120px">
              <el-option
                v-for="(code, key) in countryCodes"
                :key="key"
                :label="`+${code.code}(${code.cnName})`"
                :value="code.shortName">
              </el-option>
            </el-select>
            <el-input v-model="phone" size="mini" placeholder="请输入手机"></el-input>
          </div>
        </el-form-item>
        <el-form-item> <el-button type="primary" size="mini" @click="search">查找</el-button> </el-form-item>
      </el-form>
      <div style="padding-bottom: 10px">（建议填写手机号，可以快速与系统人员查重）</div>
    </div>
  </div>
</template>
<script>
import { countryCodes } from '../constant/common-methods'
export default {
  props: {
    handleSearch: { type: Function, default: () => {} },
    handleReparse: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      dialogVisible: false,
      phone: '',
      name: '',
      msg: '',
      countryCodes,
      country: '',
      zIndex: 1004,
    }
  },
  methods: {
    show: function(msg, defaults) {
      this.zIndex = app.root.dragindex++
      this.phone = ''
      this.name = ''
      this.country = ''
      this.msg = msg || ''
      if (defaults) {
        const { name, phone } = defaults
        this.phone = phone
        this.name = name
      }
      this.dialogVisible = true
    },
    search: async function() {
      if (!this.name && !this.phone) {
        this.msg = '请填写手机或姓名'
        return false
      }
      const countryObj = this.countryCodes.find(c => c.shortName === this.country)
      const phone = (!this.country || this.country === 'CN') ? this.phone : `${countryObj?countryObj.code:''}${this.phone}`
      const query = {}
      if (this.name) {
        query['姓名'] = this.name
      }
      if (phone) {
        query['手机'] = phone
      }
      try {
        let res = await app.service('radish').simpleList({
          query,
          fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 职能模块: 1 },
        })
        if (res.status === 'success') {
          if (res.data.length === 0 && this.name && phone) {
            res = await app.service('radish').simpleList({
              query: { 手机: phone },
              fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 职能模块: 1 },
            })
          }
          if (res.data.length === 0 && !this.name) {
            this.msg = '该手机号未查询到重复人选，请填写姓名以便于新建'
            return false
          }
          if (res.data.length === 0) {
            this.$message.success('未查询到重复人选，将新建一个人选')
          }
          this.handleSearch(res.data, { name: this.name, phone, country: this.country })
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
      this.close()
    },
    reparse() {
      this.handleReparse()
      this.dialogVisible = false
    },
    close() {
      this.dialogVisible = false
      const ref = window.app.root.$refs.cvPreview
      ref.close()
    }
  },
}
</script>
